import React from 'react';

import {InstrumentServiceDetailsLoader} from 'instruments/connections/ConnectionConstants';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';

import {AutomationOutputFileConfigGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationOutputFileConfigGraphQL';
import {AutomationOutputFileGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationOutputFileGraphQL';
import UploadAutomationOutputFileButton from './UploadAutomationOutputFileButton';

interface BaseRunAutomationOutputFileUploaderProps {
  runId: string | null;
  configName: string | null;
  automationOutputFileConfig?: AutomationOutputFileConfigGraphQL | null;
  locked: boolean;
  updateAutomationOutputFiles: (automationOutputFiles: Array<AutomationOutputFileGraphQL>) => void;
  previousFileNames: Set<string>;
  disabled?: boolean;
  isConnectionRun: boolean;
  connectionId: string | null;
  instrumentServiceDetails: InstrumentServiceDetailsLoader;
}

/**
 * This component simply renders an upload button for uploading blobs to create output files
 */
const RunAutomationOutputFileUploader = (
  props: BaseRunAutomationOutputFileUploaderProps
): JSX.Element | null => (
  <Row
    className="u-mini-spacing-top"
    bufferRowReset={true}
    dataTestAttrs={{component: 'RunAutomationOutputFileUploader', element: 'root'}}
  >
    <Col md={3}>
      <span className="fieldLabel-sublabel">Output</span>
    </Col>
    <Col md={9}>
      <UploadAutomationOutputFileButton
        runId={props.runId}
        configName={props.configName}
        automationOutputFileConfig={props.automationOutputFileConfig}
        disabled={props.disabled || props.locked || !props.runId}
        isConnectionRun={props.isConnectionRun}
        connectionId={props.connectionId}
        instrumentServiceDetails={props.instrumentServiceDetails}
        updateAutomationOutputFiles={props.updateAutomationOutputFiles}
        previousFileNames={props.previousFileNames}
      />
    </Col>
  </Row>
);

export default RunAutomationOutputFileUploader;
